<app-patient-info [heading]="Item"></app-patient-info>

<div class="ui-g-12" [hidden]="activatedRoute.children.length > 0">
  <p-table
    #dt
    *ngIf="documents"
    [responsive]="true"
    [columns]="cols"
    [value]="documents.data"
    [(selection)]="selecteditems"
    dataKey="documentID"
    [resetPageOnSort]="false"
    [lazy]="false"
    [rows]="rows"
    [paginator]="true"
    [autoLayout]="true"
  >
    <ng-template pTemplate="caption">
      <div
        class="grid col-12 md:col-12 pb-0"
        style="display: flex; align-items: flex-end"
      >
        <span class="col-12 md:col-11"> </span>
        <div class="col-12 md:col-1 pb-0" style="text-align: right">
          <p-inputSwitch
            (onChange)="toggleActivation($event)"
            onLabel="On"
            offLabel="Off"
            class="input-switch"
            [(ngModel)]="isActive"
          ></p-inputSwitch>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns" [pSortableColumn]="col.field">
          {{ col.header }}
          <p-sortIcon
            [field]="col.field"
            ariaLabel="Activate to sort"
            ariaLabelDesc="Activate to sort in descending order"
            ariaLabelAsc="Activate to sort in ascending order"
          ></p-sortIcon>
        </th>
        <th>View</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-rowData
      let-columns="columns"
      let-i="rowIndex"
    >
      <tr [pSelectableRow]="rowData">
        <td *ngFor="let col of columns" class="p-d-flex p-a">
          <div
            *ngIf="
              col.header == 'Visit Date' || col.header == 'Create Date';
              then nested_object_content;
              else normal_content
            "
          ></div>
          <ng-template #nested_object_content>
            {{ formatdatetime(rowData[col.field], col.header) }}
          </ng-template>
          <ng-template #normal_content>
            {{ rowData[col.field] }}
          </ng-template>
        </td>

        <td>
          <button
            pButton
            type="button"
            icon="pi pi-book"
            class="ui-button-success"
            (click)="viewDoc(rowData)"
            style="font-size: 0.7em"
          ></button>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <div class="w-12 bg-white">
        <div class="" style="text-align: center">
          <img
            _ngcontent-ng-c683320295=""
            class="profile-image"
            style="border-radius: 50%; width: 10rem; padding-top: 1rem"
            src="assets/imagesNew/table_error.png"
          />
        </div>
        <hr style="margin-bottom: 0.5rem" />
        <div
          class=""
          style="text-align: center; font-size: larger; color: #1d428f"
        >
          <i>No Records found.</i>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="paginatorleft" let-state>
      Showing {{ state.page * state.rows + 1 }} to
      {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }} records.
    </ng-template>
  </p-table>
</div>

<div class="mt-2">
  <p-button label="Back" (click)="back()"></p-button>
  <hr />
</div>
<div [hidden]="activatedRoute.children.length === 0">
  <router-outlet></router-outlet>
</div>
